"use client";

import { useRouter } from "next/navigation";
import React from "react";

interface BackButtonProps {
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ className = "" }) => {
  const router = useRouter();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push("/listings");
    }
  };

  return (
    <button
      onClick={handleGoBack}
      className={`fixed top-4 left-4 z-50 p-2 bg-white border border-black hover:bg-light-grey transition-colors font-raleway text-sm ${className}`}
      aria-label="Go back"
    >
      ← Back
    </button>
  );
};

export default BackButton;
